// 開いた時のイベント
export function toggleCollapse () {
  let links = document.querySelectorAll('.callapse-toggle');
  let openLink = document.querySelector('.callapse-open');
  let closeLinks = document.querySelectorAll('.callapse-close');
  let collapse = document.querySelector('.collapse');

  for (let i = 0; i < links.length; i++) {
    links[i].addEventListener('click', function(event) {
      if (event.target.classList.contains('callapse-open') && !collapse.classList.contains('show')) {
        openLink.classList.add('d-none');
        for (let t = 0; t < closeLinks.length; t++) {
          closeLinks[t].classList.remove('d-none');
        }
      } else {
        openLink.classList.remove('d-none');
        for (let t = 0; t < closeLinks.length; t++) {
          closeLinks[t].classList.add('d-none');
        }
      }
    })
  }
}
